import DeleteButton from 'CMFW/button/DeleteButton';
import SaveButton from 'CMFW/button/SaveButton';
import ModuleContext from 'CMFW/context/ModuleContext';
import { ContainerRight, EditorRow } from 'components/common/styles';
import React, { useCallback, useContext } from 'react';
import styled from 'styled-components';
import ItemLayout from '../../../CMFW/layout/ItemLayout';
import Translations from '../../../components/translation/Translations';
import { LoadingItem } from '../../../CMFW/layout/Loading';
import { IRefIds } from '../../../constants/refs';
import { VocCategoryRootSelect } from '../../../components/selects/VocCategoryRootSelect';
import Checkbox from '../../../CMFW/input/Checkbox';
import TextInput from '../../../CMFW/input/TextInput';
import IllustrationPNG from '../../compounds/IllustrationPNG';
import IllustrationModel from '../../../models/IllustrationModel';
import { IIllustration } from '../../../types/illustration';
import VocCategoryModel from '../../../models/VocCategoryModel';

const VocCategoryEdit: React.FC = () => {
  const module = useContext(ModuleContext) as VocCategoryModel;
  const illustrationModel = new IllustrationModel();

  const illustration: IIllustration | undefined = module.getItemValue('illustration');
  const isSubCategory: boolean = module.getItemValue('isSubCategory') ?? false;
  const categoryId: number = module.getItemValue('id') ?? 0;

  const handleUpload = useCallback(
    async (file: File) => {
      return await illustrationModel.uploadVocCategoryPNG(categoryId, file);
    },
    [categoryId, illustrationModel]
  );

  const handleDelete = useCallback(async () => {
    await illustrationModel.deleteVocCategoryPNG(categoryId);
  }, [categoryId, illustrationModel]);

  const handleReload = useCallback(() => {
    module.reloadItem();
  }, [module]);

  return (
    <ContainerRightStyled>
      <ItemLayout>
        <EditorRow>
          <VocCategoryRootSelect />
          <SaveButton />
        </EditorRow>
        <Scroll>
          <Checkbox keyName="showInLibrary" label="Show in library (CA app)" />
          <Checkbox keyName="searchableInLibrary" label="Searchable in library (CA app)" />
          {isSubCategory && illustration && (
            <IllustrationSection>
              <IllustrationPNG
                illustration={illustration}
                onUpload={handleUpload}
                onDelete={handleDelete}
                onReload={handleReload}
                showStages={false}
                uploadTitle="Upload Category Illustration"
                uploadDescription="Upload a PNG image (500x380 pixels) for this category."
              />
            </IllustrationSection>
          )}
          <TextInput
            keyName="description"
            label="Description (for AI categorization)"
            placeholder="Describe what types of vocabulary belong in this category..."
            multiline
            rows={4}
            fullWidth
            helperText="This helps the AI suggest appropriate categories for new vocabulary"
            margin="normal"
          />
          <Translations keyName={'sources'} refId={IRefIds.vocabularyCategories} />
        </Scroll>
        <DeleteButton />
      </ItemLayout>
      <LoadingItem />
    </ContainerRightStyled>
  );
};

export default VocCategoryEdit;

export const ContainerRightStyled = styled(ContainerRight)``;

const Scroll = styled.div`
  flex-grow: 1;
  overflow: auto;
  padding-bottom: 10px;
  padding-right: 10px;
`;

const IllustrationSection = styled.div`
  margin-bottom: 16px;
  width: fit-content;
`;
